import { PlannedDurationSettings } from '@cbgms/api/modules/workorder/planned-duration-settings'
import {
  getAppointmentPlannedDurationSettings,
  putAppointmentPlannedDurationSettings
} from '@cbgms/api/modules/workorder/planned-duration-settings/requests'
import useQuery, { UseQueryOptions, useMutation, useQueryClient } from '@cbgms/base/http/use-query'
import { useGetCurrentShopID } from 'app/shops/hooks/useGetCurrentShopID'
import { useDispatch } from 'react-redux'

const PLANNED_DURATION_SETTINGS_KEY = 'PLANNED_DURATION_SETTINGS_KEY'
const plannedDurationSettingsCacheKey = (shopID: string) => [PLANNED_DURATION_SETTINGS_KEY, shopID]

export const useGetPlannedDurationSettings = (
  options?: UseQueryOptions<PlannedDurationSettings, unknown, PlannedDurationSettings, string[]>
) => {
  const dispatch = useDispatch()
  const shopID = useGetCurrentShopID()
  return useQuery(
    plannedDurationSettingsCacheKey(shopID),
    async () => {
      const { Data } = await dispatch(getAppointmentPlannedDurationSettings())
      return Data
    },
    // This setting is shop-scoped on the backend (SettingsLevelShop) - don't fetch (or cache
    // under) an empty shopID, e.g. right after login before `currentShop` has resolved.
    { enabled: !!shopID, ...options }
  )
}

export const usePlannedDurationSettingsMutator = () => {
  const dispatch = useDispatch()
  const queryClient = useQueryClient()

  return useMutation(
    async (newValues: PlannedDurationSettings) => {
      return dispatch(putAppointmentPlannedDurationSettings(newValues))
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([PLANNED_DURATION_SETTINGS_KEY])
      }
    }
  )
}

export default useGetPlannedDurationSettings
